import { ProfessionalActivity } from "@models/clients/professionalActivity";
import { ClientCRMRepo } from "@services/clients/clientCRM.repo";

class ProfessionalActivityController {
  public professionalActivity: ProfessionalActivity;
  public isLoading: boolean = false;
  public isEditMode: boolean = false;
  public professionalActivityForm: angular.IFormController;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private clientCRMRepo: ClientCRMRepo
  ) {}

  $onInit() {
    // Initialize professional activity object - create a copy to avoid modifying the original
    if (this.professionalActivity) {
      this.professionalActivity = { ...this.professionalActivity }; // Create a shallow copy
      this.isEditMode = this.professionalActivity.id > 0;
    } else {
      this.professionalActivity = { id: 0, name: '' };
      this.isEditMode = false;
    }
  }

  public saveProfessionalActivity() {
    // Trigger form validation
    this.professionalActivityForm.$setSubmitted();
    
    // Check if form is valid
    if (this.professionalActivityForm.$invalid) {
      return;
    }

    this.isLoading = true;
    
    // Call the single saveProfessionalActivity endpoint - backend will determine if it's create or update based on the ID
    this.clientCRMRepo.saveProfessionalActivity(this.professionalActivity)
      .then((result) => {
        this.$mdDialog.hide(this.professionalActivity);
      })
      .catch((error) => {
        // You could add error handling/notification here
        this.isLoading = false;
      });
  }

  public cancel() {
    this.$mdDialog.cancel();
  }
}

export const professionalActivityModal: angular.IComponentOptions = {
  template: require("./professionalActivity.html"),
  controller: ProfessionalActivityController,
  bindings: {
    professionalActivity: "<?"
  }
};



// WEBPACK FOOTER //
// ./src/app/clientmanagement/modals/professionalActivity.ts